import { isNil } from 'lodash';
import * as yup from 'yup';

const optionalNumberTransformer =
  () =>
  (value: number, originalValue: string): number | undefined => {
    if (originalValue === '' || isNil(originalValue)) {
      return undefined;
    }
    return value;
  };
yup.addMethod(yup.NumberSchema, 'optionalNumber', function () {
  return this.transform(optionalNumberTransformer()).nullable().default(null);
});

const optionalStringTransformer =
  () =>
  (value: string, originalValue: string): string | undefined => {
    if (originalValue === '' || isNil(originalValue)) {
      return undefined;
    }
    return value;
  };
yup.addMethod(yup.StringSchema, 'optionalString', function () {
  return this.transform(optionalStringTransformer()).nullable().default(null);
});

export default yup;

declare module 'yup' {
  interface NumberSchema {
    optionalNumber(): yup.NumberSchema<number | undefined | null>;
  }
  interface StringSchema {
    optionalString(): yup.StringSchema<string | undefined | null>;
  }
}
